import { render, staticRenderFns } from "./searchPlayersBlock.vue?vue&type=template&id=bc3b3a56&scoped=true&"
import script from "./searchPlayersBlock.vue?vue&type=script&lang=js&"
export * from "./searchPlayersBlock.vue?vue&type=script&lang=js&"
import style0 from "./searchPlayersBlock.vue?vue&type=style&index=0&id=bc3b3a56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3b3a56",
  null
  
)

export default component.exports